package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminBotRequest(
    val query: String,
    val role: String,
    @SerialName("userID")
    val userId: String,
    val organization: String,
    val seasonID: String,
    val generatePdf: Boolean = false,
    val conversationHistory: List<ConversationHistory>? = null
)

@Serializable
data class ConversationHistory(
    val role: String,
    val content: String
)